export default __webpack_public_path__ + "static/media/qcc_earnings_notifications.b7b4d0ca.svg";